module.exports = __webpack_public_path__ + "img/Green.4fb7d9dd.svg";